import ajaxService from "../utils/ajaxServices";
import microService from "../utils/microServices";
import {
  getAddressTypes,
  getSAStates,
  setExistingBillAddress,
  setNewBillingAddress,
  setExistingShippingAddress,
  setNewShippingAddress,
  createCustomerAddress,
  updateCustomerAddress,
  getAllCustomerAddressLists,
  getCustomerActiveCart,
  setShippingMethodsOnCart,
  setPaymentMethodOnCart,
  placeOrder,
  salesOrderDetail,
  setGuestEmailOnCart,
} from "../config/queries";
import { LEAD_BUCKETS } from "../config/constants";
import { journeyType } from "../context/checkout-journey-context";

import {
  Logger,
} from "../utils/logger";

export const getAddressTypesService = async () => {
  try {
    const result = await ajaxService.fetchGraphQLGetRequest(getAddressTypes);

    let dataResults = { fail: false, addressTypeData: [] };

    if (
      result &&
      result.addressType &&
      result.addressType.allOptions &&
      result.addressType.allOptions.length
    ) {
      dataResults.addressTypeData = result.addressType.allOptions;
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const getSAStatesService = async () => {
  try {
    const result = await ajaxService.fetchGraphQLGetRequest(getSAStates);

    let dataResults = { fail: false, countryRegions: {} };

    if (
      result &&
      result.country &&
      result.country.available_regions &&
      result.country.available_regions.length
    ) {
      const { id, full_name_english, available_regions } = result.country;
      dataResults.countryRegions = {
        countryCode: id,
        countryName: full_name_english,
        regions: available_regions,
      };
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const getAllCustomerAddressListsService = async () => {
  try {
    const result = await ajaxService.fetchGraphQLPOSTRequest(
      getAllCustomerAddressLists,
      {}
    );

    let dataResults = { fail: false, customerData: {}, addressList: [] };

    if (result && result.customer) {
      dataResults.customerData.firstName = result.customer.firstname;
      dataResults.customerData.surName = result.customer.lastname;
      dataResults.customerData.telephone = result.customer.telephone;
      dataResults.customerData.email = result.customer.email;

      if (result.customer.addresses) {
        dataResults.addressList = result.customer.addresses;
      }
    } else {
      dataResults.fail = true;
    }
    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const setNewShippingAddressService = async (inputData = {}) => {
  try {
    const result = await ajaxService.fetchGraphQLPOSTRequest(
      setNewShippingAddress,
      inputData
    );
    let dataResults = { fail: false, setAddress: {} };

    if (
      result &&
      result.setShippingAddressesOnCart &&
      result.setShippingAddressesOnCart.cart &&
      result.setShippingAddressesOnCart.cart.shipping_addresses &&
      result.setShippingAddressesOnCart.cart.shipping_addresses.length
    ) {
      dataResults.setAddress =
        result.setShippingAddressesOnCart.cart.shipping_addresses;
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const setExistingShippingAddressService = async (
  cart_id,
  address_id
) => {
  try {
    const result = await ajaxService.fetchGraphQLPOSTRequest(
      setExistingShippingAddress,
      {
        cart_id: cart_id,
        customer_address_id: address_id,
      }
    );

    let dataResults = { fail: false, setAddress: {} };

    if (
      result &&
      result.setShippingAddressesOnCart &&
      result.setShippingAddressesOnCart.cart &&
      result.setShippingAddressesOnCart.cart.shipping_addresses &&
      result.setShippingAddressesOnCart.cart.shipping_addresses.length
    ) {
      dataResults.setAddress =
        result.setShippingAddressesOnCart.cart.shipping_addresses;
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};
export const setNewBillingAddressService = async (inputData = {}) => {
  try {
    const result = await ajaxService.fetchGraphQLPOSTRequest(
      setNewBillingAddress,
      inputData
    );

    let dataResults = { fail: false, setAddress: {} };

    if (
      result &&
      result.setBillingAddressOnCart &&
      result.setBillingAddressOnCart.cart &&
      result.setBillingAddressOnCart.cart.billing_address &&
      Object.keys(result.setBillingAddressOnCart.cart.billing_address).length
    ) {
      dataResults.setAddress =
        result.setBillingAddressOnCart.cart.billing_address;
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const setExistingBillAddressService = async (
  cart_id,
  address_id,
  same_as_shipping
) => {
  try {
    const result = await ajaxService.fetchGraphQLPOSTRequest(
      setExistingBillAddress,
      {
        cart_id: cart_id,
        customer_address_id: address_id,
        same_as_shipping: same_as_shipping,
      }
    );

    let dataResults = { fail: false, setAddress: {} };

    if (
      result &&
      result.setBillingAddressOnCart &&
      result.setBillingAddressOnCart.cart &&
      result.setBillingAddressOnCart.cart.billing_address &&
      Object.keys(result.setBillingAddressOnCart.cart.billing_address).length
    ) {
      dataResults.setAddress =
        result.setBillingAddressOnCart.cart.billing_address;
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const updateCustomerAddressService = async (inputData = {}) => {
  try {
    const result = await ajaxService.fetchGraphQLPOSTRequest(
      updateCustomerAddress,
      inputData
    );

    let dataResults = { fail: false, updatedAddress: {} };

    if (
      result &&
      result.updateCustomerAddress &&
      Object.keys(result.updateCustomerAddress).length
    ) {
      dataResults.updatedAddress = result.updateCustomerAddress;
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const createCustomerAddressService = async (inputData = {}) => {
  try {
    const result = await ajaxService.fetchGraphQLPOSTRequest(
      createCustomerAddress,
      inputData
    );

    let dataResults = { fail: false, createAddress: {} };

    if (
      result &&
      result.createCustomerAddress &&
      Object.keys(result.createCustomerAddress).length
    ) {
      dataResults.createAddress = result.createCustomerAddress;
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const deleteCustomerAddressService = async (id) => {
  try {
    const deleteCustomerAddressMutation = `mutation {deleteCustomerAddress(
      id: ${id}
    )}`;
    const result = await ajaxService.fetchGraphQLPOSTRequest(
      deleteCustomerAddressMutation
    );

    let dataResults = { fail: false, deletedAddress: false };

    if (result && result.deleteCustomerAddress) {
      dataResults.deletedAddress = result.deleteCustomerAddress;
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const getCustomerActiveCartService = async () => {
  try {
    const result = await ajaxService.fetchGraphQLPOSTRequest(
      getCustomerActiveCart
    );
    let activeCartId;

    if (result && result.customerCart && result.customerCart.id) {
      activeCartId = result.customerCart.id;
    } else {
      activeCartId = "";
    }

    return activeCartId;
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const setShippingMethodsOnCartService = async (
  cart_id,
  carrier_code,
  method_code
) => {
  try {
    const result = await ajaxService.fetchGraphQLPOSTRequest(
      setShippingMethodsOnCart,
      {
        cart_id: cart_id,
        carrier_code: carrier_code,
        method_code: method_code,
      }
    );

    let dataResults = { fail: false, shippingMethod: {} };

    if (
      result &&
      result.setShippingMethodsOnCart &&
      Object.keys(result.setShippingMethodsOnCart).length
    ) {
      dataResults.shippingMethod = result.setShippingMethodsOnCart;
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const setPaymentMethod = async (
  cart_id,
  totalZero,
  paymentMethodCode = "checkmo"
) => {
  try {
    const result = await ajaxService.fetchGraphQLPOSTRequest(
      setPaymentMethodOnCart,
      {
        cart_id: cart_id,
        payment_code: totalZero == "true" ? "free" : paymentMethodCode,
      }
    );

    let dataResults = { fail: false, paymentMethod: {} };

    if (
      result &&
      result.setPaymentMethodOnCart &&
      Object.keys(result.setPaymentMethodOnCart).length
    ) {
      dataResults.paymentMethod = result.setPaymentMethodOnCart;
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const setPlaceOrder = async (cart_id) => {
  try {
    const result = await ajaxService.fetchGraphQLPOSTRequest(placeOrder, {
      cart_id: cart_id,
    });

    let dataResults = { fail: false, order: {} };

    if (result && result.placeOrder && Object.keys(result.placeOrder).length) {
      dataResults.order = result.placeOrder.order;
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const getSalesOrder = async (id) => {
  try {
    const result = await ajaxService.fetchGraphQLPOSTRequest(salesOrderDetail, {
      id: id,
    });

    let dataResults = { fail: false, order: {} };

    if (result && result.salesOrder && Object.keys(result.salesOrder).length) {
      dataResults.order = result.salesOrder;
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const setGuestEmailOnCartService = async (cart_id, email) => {
  try {
    const result = await ajaxService.fetchGraphQLPOSTRequest(
      setGuestEmailOnCart,
      {
        cart_id: cart_id,
        email: email,
      }
    );

    let dataResults = { fail: false, email: {} };

    if (
      result &&
      result.setGuestEmailOnCart &&
      result.setGuestEmailOnCart.cart.email
    ) {
      dataResults.email = result.setGuestEmailOnCart.cart.email;
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const updateProfileDataService = async (inputData = {}) => {
  try {
    const result = await ajaxService.httpPostGrpahQL(
      "restUrl",
      JSON.stringify(inputData),
      "api",
      "profileUpdate",
      true
    );

    let dataResults = { fail: false, profile: {} };

    if (result && result[0] && result[0].ProfileID) {
      dataResults.profile = result[0];
    } else {
      dataResults.fail = true;
    }

    return { ...dataResults, errors: result?.errors, status: result?.status };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const preValidationCheckService = async (
  idType,
  idNumber,
  dealId,
  journeyType
) => {
  let reqParams = [idNumber];
  let queryParams = `?idType=${idType}&dealId=${dealId}&journeyType=${journeyType}`;

  try {
    const result = await microService.get(
      "api",
      "preValidation",
      null,
      true,
      reqParams,
      queryParams
    );

    let dataResults = {
      responseCode: null,
      skipCreditVetting: false,
      creditFilters: {},
    };

    if (result.response?.data) {
      if (result.response.data?.responseCode) {
        dataResults.responseCode = result.response.data.responseCode;
      }

      if (
        result.response.data?.skipCreditVetting &&
        result.response.data?.skipCreditVetting == true
      ) {
        dataResults.skipCreditVetting = true;
      }

      if (result.response.data?.creditFilters) {
        dataResults.creditFilters = result.response.data.creditFilters;
      }
    }

    return { ...dataResults, errors: result?.error };
  } catch (error) {

    Logger.error(
      error,
      "preValidationCheckService",
      {
        request: {
          idType,
          idNumber,
          dealId,
          journeyType
        }
      }
    );
  }
};

export const getCordsService = async (addressStr) => {
  let queryParams = `?input=${addressStr}`;

  try {
    const result = await microService.get(
      "api",
      "getCords",
      null,
      true,
      null,
      queryParams
    );

    return { ...result, errors: result?.error };
  } catch (error) {
    console.log("Technical error", error);
    return error;
  }
};

export const getGeographicSiteStockService = async (
  clientType,
  deviceId,
  latitude,
  longitude,
  stockCode,
  storeTypes
) => {
  const queryParams = `?clientType=${clientType}&deviceId=${deviceId}&latitude=${latitude}&longitude=${longitude}&stockCode=${stockCode}&storeTypes=${storeTypes}`;

  try {
    const result = await microService.get(
      "api",
      "geoGraphicSiteStock",
      null,
      false,
      null,
      queryParams
    );

    return { ...result, errors: result?.error };
  } catch (error) {
    console.log("Technical error", error);
  }
};

export const getLeadBucket = (step, journey= null) => {
  let bucket = LEAD_BUCKETS.general;
  switch (step) {
    case "authentication":
      bucket = LEAD_BUCKETS.startCheckout;
      break;
    case "otp":
      if(journey === journeyType.upgrade) {
        bucket = LEAD_BUCKETS.upgrade.otpAuth;
      }else {
        bucket = LEAD_BUCKETS.addLine.otpAuth;
      }
      break;
    case "xds":
      bucket = LEAD_BUCKETS.addLine.xds;
      break;
    case "creditCheck":
      bucket = LEAD_BUCKETS.addLine.creditVetting;
      break;
    case "numberTransfer":
      bucket = LEAD_BUCKETS.addLine.numberTransfer;
      break;
    case "payment":
    case "paymentError":
    case "paymentRedirect":
      bucket = LEAD_BUCKETS.payment;
      break;
    case "delivery":
      bucket = LEAD_BUCKETS.delivery;
      break;
    case "review":
      bucket = LEAD_BUCKETS.orderReview;
      break;
    case "orderConfirmation":
      bucket = LEAD_BUCKETS.orderConfirmation;
      break;
  }
return bucket;

};
